<template>
  <el-container>
    <el-header class="fixed-head">
      <common-header />
    </el-header>
    <el-main>
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>
import CommonHeader from './CommonHeader.vue';

export default {
  name: 'FramePage',
  data() {
    return {};
  },
  components: {
    CommonHeader,
  },
};
</script>

<style scoped lang="less">
.fixed-head {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2001;
  transition: all 0.8s;
  opacity: .96;
}

.el-header {
  height: auto !important;
  min-width: 1400px;
  background-color: #FFFFFF;
  padding: 0;
}

.el-main {
  padding: 0;
  padding-top: 125px !important;
  background-color: #ffffff;
  min-height: calc(100vh - 125px);
  margin: 0 auto;
  width: 100%;
  min-width: 1400px
}
</style>
